export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Spinner.vue?vue&type=template&id=39432f99&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Spinner.vue?vue&type=template&id=39432f99&
// module id = 534
// module chunks = 3